import { DriverSchema } from "mock/schemas"

type DriverSchemaArray = [string, string, string, string, boolean, string]

const driversArray: DriverSchemaArray[] = [
    ["1", "Jeanne", "Berger", "jberger@ortec.fr", true, "1"],
    ["2", "Camille", "Deniaud", "cdeniaud@ortec.fr", true, "1"],
    ["3", "Claire", "Beaufort", "cbeaufort@ortec.fr", false, "1"],
    ["4", "Ange", "Lucas", "alucas@ortec.fr", true, "1"],
    ["5", "Rodrigue", "Denis", "rdenis@ortec.fr", false, "1"],
    ["6", "Jules", "Coste", "jcoste@ortec.fr", false, "1"],
    ["7", "Dominique", "Augustin", "daugustin@ortec.fr", true, "1"],
    ["8", "Céleste", "Labelle", "clabelle@ortec.fr", false, "1"],
    ["9", "Corine", "Giroux", "cgiroux@ortec.fr", true, "1"],
    ["10", "Corinne", "Béranger", "cberanger@ortec.fr", true, "1"],
    ["11", "Delphine", "Duguay", "dduguay@ortec.fr", true, "1"],
    ["12", "Guy", "Roy", "groy@ortec.fr", false, "1"],
    ["13", "Ouida", "Voclain", "ovoclain@ortec.fr", false, "1"],
    ["14", "Donatienne", "Comtois", "dcomtois@ortec.fr", true, "1"],
    ["15", "Anaïs", "Soucy", "anaissoucy@oreve.fr", false, "2"],
    ["16", "Avril", "Monette", "avrilmonette@oreve.fr", true, "2"],
    ["17", "Marthe", "Bourreau", "marthebourreau@oreve.fr", true, "2"],
    ["18", "Bianca", "Paquet", "biancapaquet@oreve.fr", true, "2"],
    ["19", "Amaline", "Langlais", "amalinelanglais@oreve.fr", false, "2"],
    ["20", "Benjamine", "Forestier", "benjamineforestier@oreve.fr", true, "2"],
    ["21", "Orianne", "Fabien", "oriannefabien@oreve.fr", false, "2"],
    ["22", "Raimund", "Blanchet", "raimundblanchet@oreve.fr", true, "2"],
    ["23", "Arianne", "Joubert", "ariannejoubert@oreve.fr", false, "2"],
    ["24", "Toussaint", "Babineaux", "toussaintbabineaux@oreve.fr", true, "2"],
]

const createDriverObject = (arr: DriverSchemaArray): DriverSchema => {
    return {
        id: arr[0],
        firstName: arr[1],
        lastName: arr[2],
        email: arr[3],
        active: arr[4],
        entity_id: arr[5],
    }
}

export const driversMockDatas: DriverSchema[] = driversArray.map((arr) =>
    createDriverObject(arr)
)
